<template>
  <b-list-item class="b-menu-item">
    <slot />
  </b-list-item>
</template>
